import { uploadCaseZips } from "@/core/app/slices/clinical/clinicalThunkApi"
import {
  caseManagement,
  stageControl,
  stagingManager,
  wasmModule,
} from "@/gluelayer"
import { Box, Paper, Stack, experimentalStyled as styled } from "@mui/material"
import { useEffect, useImperativeHandle, useRef, useState } from "react"

import { UButton } from "@/components/index"
import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { stagingIPR } from "@/gluelayer"
import DialogBox from "@/modules/Clinical/components/DialogBox/dialogBox"
import { EBiteJump } from "@/shared/types"
import { setReportData } from "@/UDTreat/udTreatSlice"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import { isNodeContains } from "./stageCommon"
import StageFoldItemForIpr from "./stageFoldItemForIpr"
import StageGmButton from "./stageGmButton"
import StageItemForIpr from "./stageItemForIpr"
import StageItemNone from "./stageItemNone"

const ButtonItem = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.palette.text.secondary,
}))

const StageArchForIpr = (props) => {
  // const [stageCurrentStep, setStageCurrentStep] = useState(props.currentStep);
  // const [stageCurrentNodeType, setStageCurrentNodeType] = useState([]);
  const dispatch = useDispatch()
  const [stageList, setStageList] = useState([])
  const moreStageItem = {
    indexStr: "",
    nodeTypes: [0],
  }
  // const [isCurrentStepChangedByClick, setIsCurrentStepChangedByClick] = useState(false);
  //const [isGmClicked, setIsGmClicked] = useState(false);
  //const [gmPercent, setGmPercent] = useState(0.0);
  const { stageGmLocation, reportData } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const { patientId, caseId } = useParams()
  const stepRef = useRef({})
  const isStageItemForIprRef = useRef({})
  const singleStageWidth = 23
  const StageDiv = 4
  const singleStageHeight = 27
  // const [actualStageWidth, setActualStageWidth] = useState<number>(singleStageWidth)
  // const [gmUiLocation, setGmUiLocation] = useState("end")//start end
  const [showDeleteNodeWarning, setShowDeleteNodeWarning] = useState(false)
  const [
    showDeletePassiveAlignerNodeWarning,
    setShowDeletePassiveAlignerNodeWarning,
  ] = useState(false)
  const [showCannotAddIprNodeWarning, setShowCannotAddIprNodeWarning] =
    useState(false)
  const [isAddMore, setIsAddMore] = useState(false)
  const firstCollisionStage = stagingIPR.getCollisionStage(props.archType)

  useImperativeHandle(props.onRef, () => ({
    getStagePositionX,
    getStageStepByPositionX,
    setCurrentStep,
    // calcMaxArchWidth,
  }))

  const callBackStepRef = (e: HTMLElement, stepIndex: number) => {
    stepRef.current["step_" + stepIndex] = e
    // console.info("stepIndex:", stepIndex, e)
  }

  const setCurrentStep = (step: number) => {
    // setStageCurrentStep(step)
  }

  const changeCurrentStep = (iStep) => {
    //if(isCurrentStepChangedByClick) {
    // props.stepChangeHandler(props.archType, iStep)
    //}
    //setStageCurrentStep(iStep);
  }

  const stageButtonClickHandle = (item, index, itemArray) => {
    //getStagePosition(index)
    // setIsCurrentStepChangedByClick(true)
    // console.info(
    //   "=====isCurrentStepChangedByClick: ",
    //   isCurrentStepChangedByClick,
    //   props.archName,
    // )
    // changeCurrentStep(index)
    if (index < props.nodes.length) {
      props.stepChangeHandler(props.archType, index)
    }
  }

  const getStagePositionX = (stepIndex: number) => {
    //var rect = element.getBoundingClientRect();
    //return { x: rect.left, y: rect.top };
    const e = stepRef.current["step_" + stepIndex]
    if (e === undefined || e === null) {
      return 0
    }
    const rect = e.getBoundingClientRect()
    let eWidth = rect.width
    const isStageItemForIpr =
      isStageItemForIprRef.current["isStageItemForIpr_" + stepIndex]
    if (isStageItemForIpr) {
      eWidth = rect.width / 2.0 + singleStageWidth / 2.0 + 2.5
    }
    const middleX = rect.left + eWidth

    const parentE = e.offsetParent
    let parentELeft = 0
    if (parentE !== undefined && parentE !== null) {
      const parentRect = parentE.getBoundingClientRect()
      parentELeft = parentRect.left
    }

    //console.info("=====getStagePositionX: ", middleX);
    return middleX - parentELeft
  }

  const getStageStepByPositionX = (positionX: number) => {
    for (let i = 0; i < props.nodes.length; i++) {
      const xMiddle = getStagePositionX(i)
      if (
        xMiddle - (singleStageWidth + StageDiv) / 2 <= positionX &&
        positionX <= xMiddle + (singleStageWidth + StageDiv) / 2
      ) {
        return i
      }
    }
    return -1
  }

  const addNodeHandler = () => {
    if (!props.viewEdit) {
      return
    }

    const addRet = stagingIPR.addNewIPRNode(props.archType, props.currentStep)
    console.info("addNodeHandler addRet:", addRet)
    if (!addRet) {
      setShowCannotAddIprNodeWarning(true)
      return
    }
  }

  const deleteNodeHandler = () => {
    if (!props.viewEdit) {
      return
    }
    setShowDeleteNodeWarning(true)
  }

  const addMoreHandler = () => {
    console.info("addMoreHandler, archType:", props.archType)
    setIsAddMore(true)
  }

  const judgeWhichItem = (item, index, itemArray) => {
    if (props.countOfFoldGroup === 1) {
      isStageItemForIprRef.current["isStageItemForIpr_" + index] = true
      return (
        <StageItemForIpr
          archType={props.archType}
          index={index}
          stageCurrentStep={props.currentStep}
          isNodeContains={isNodeContains}
          item={item}
          itemArray={itemArray}
          addNodeHandler={addNodeHandler}
          deleteNodeHandler={deleteNodeHandler}
          stageButtonClickHandle={stageButtonClickHandle}
          stageDiv={StageDiv}
          singleStageWidth={singleStageWidth}
          singleStageHeight={singleStageHeight}
          countOfFoldGroup={props.countOfFoldGroup}
          actualStageWidth={props.actualSingleStageWidth}
          uiShowType={props.uiShowType}
          viewEdit={props.viewEdit}
          upQuick3Index={props.upQuick3Index}
          downQuick3Index={props.downQuick3Index}
          iprPositionXChanged={props.iprPositionXChanged}
          iprDragStoped={props.iprDragStoped}
          iprDragFromStep={props.iprDragFromStep}
          iprDragToStep={props.iprDragToStep}
          firstCollisionStage={firstCollisionStage}
        />
      )
    } else if (props.countOfFoldGroup > 1) {
      const remainder = index % props.countOfFoldGroup
      const quotient = Math.floor(index / props.countOfFoldGroup)
      if (
        index === 0 ||
        index === stageList.length - 1 ||
        (remainder === 0 &&
          quotient * props.countOfFoldGroup + 1 !== stageList.length - 1)
      ) {
        isStageItemForIprRef.current["isStageItemForIpr_" + index] = true
        return (
          <StageItemForIpr
            archType={props.archType}
            index={index}
            stageCurrentStep={props.currentStep}
            isNodeContains={isNodeContains}
            item={item}
            itemArray={itemArray}
            addNodeHandler={addNodeHandler}
            deleteNodeHandler={deleteNodeHandler}
            stageButtonClickHandle={stageButtonClickHandle}
            stageDiv={StageDiv}
            singleStageWidth={singleStageWidth}
            singleStageHeight={singleStageHeight}
            countOfFoldGroup={props.countOfFoldGroup}
            actualStageWidth={props.actualSingleStageWidth}
            uiShowType={props.uiShowType}
            viewEdit={props.viewEdit}
            upQuick3Index={props.upQuick3Index}
            downQuick3Index={props.downQuick3Index}
            iprPositionXChanged={props.iprPositionXChanged}
            iprDragStoped={props.iprDragStoped}
            iprDragFromStep={props.iprDragFromStep}
            iprDragToStep={props.iprDragToStep}
            firstCollisionStage={firstCollisionStage}
          />
        )
      }
      // else if(remainder === 0 && (quotient*props.countOfFoldGroup + 1) === (stageList.length - 1)) {
      //   return <StageFoldItem
      //     archType={props.archType}
      //     index={index}
      //     stageCurrentStep={stageCurrentStep}
      //     isNodeContains={isNodeContains}
      //     item={item}
      //     itemArray={itemArray}
      //     addNodeHandler={addNodeHandler}
      //     stageButtonClickHandle={stageButtonClickHandle}
      //     stageDiv={StageDiv}
      //     singleStageWidth={singleStageWidth}
      //     singleStageHeight={singleStageHeight}
      //     scaleHeight={4}
      //     countOfFoldGroup={props.countOfFoldGroup}
      //     isBigNode={true} />
      // }
      else {
        isStageItemForIprRef.current["isStageItemForIpr_" + index] = false
        return (
          <StageFoldItemForIpr
            archType={props.archType}
            index={index}
            stageCurrentStep={props.currentStep}
            isNodeContains={isNodeContains}
            item={item}
            itemArray={itemArray}
            addNodeHandler={addNodeHandler}
            deleteNodeHandler={deleteNodeHandler}
            stageButtonClickHandle={stageButtonClickHandle}
            stageDiv={StageDiv}
            singleStageWidth={singleStageWidth}
            singleStageHeight={singleStageHeight}
            scaleHeight={4}
            countOfFoldGroup={props.countOfFoldGroup}
            actualStageWidth={props.actualSingleStageWidth}
            uiShowType={props.uiShowType}
            isBigNode={false}
            viewEdit={props.viewEdit}
            upQuick3Index={props.upQuick3Index}
            downQuick3Index={props.downQuick3Index}
            iprPositionXChanged={props.iprPositionXChanged}
            iprDragStoped={props.iprDragStoped}
            iprDragFromStep={props.iprDragFromStep}
            iprDragToStep={props.iprDragToStep}
            firstCollisionStage={firstCollisionStage}
          />
        )
      }
    }
  }

  const loadStageUi = () => {
    if (stageList.length > 0) {
      return stageList.map((item, index, itemArray) => {
        return (
          <Stack
            ref={(e: HTMLElement) => {
              callBackStepRef(e, index)
            }}
            direction="row"
            spacing={0}
            key={item.indexStr}
            sx={{
              position: "relative", // 必须设置 position
              zIndex: stageList.length - index, // 后面的元素 z-index 更小
            }}
          >
            {judgeWhichItem(item, index, itemArray)}
          </Stack>
        )
      })
    } else if (props.refineNumber >= 0) {
      return (
        <StageItemNone
          archType={props.archType}
          stageDiv={StageDiv}
          singleStageWidth={singleStageWidth}
          singleStageHeight={singleStageHeight}
          countOfFoldGroup={props.countOfFoldGroup}
          actualStageWidth={props.actualSingleStageWidth}
          nameStr={props.refineNumber === 0 ? "0" : "R" + props.refineNumber}
        />
      )
    }
  }

  const loadStageData = () => {
    console.info(
      "loadStageData=====nodes count",
      props.nodes.length,
      props.archName,
    )
    var newStageList = []
    for (var i = 0; i < props.nodes.length; i++) {
      //console.info("=====", props.nodes[i].stepindex, props.nodes[i].name, props.nodes[i].nodeType);
      newStageList.push({
        indexStr: props.nodes[i].name,
        nodeTypes: props.nodes[i].nodeType,
      })
    }

    console.info("=====set stageList", props.archName, newStageList.length)
    setStageList(newStageList)

    console.info("=====stageCurrentStep: ", props.archName, props.currentStep)
    // setIsCurrentStepChangedByClick(false)
  }

  // const calcStageWidth = () => {
  //   if (props.countOfFoldGroup === 1) {
  //     setActualStageWidth(singleStageWidth)
  //   } else if (props.countOfFoldGroup === 5) {
  //     setActualStageWidth(singleStageWidth - 6)
  //   } else if (props.countOfFoldGroup === 10) {
  //     setActualStageWidth(singleStageWidth - 10)
  //   } else if (props.countOfFoldGroup === 20) {
  //     setActualStageWidth(singleStageWidth - 10)
  //   }
  // }

  const loadGmButton = (isFront) => {
    if (stageList.length <= 0 || !props.isDownArchBiteMoved()) {
      return <></>
    }

    if (props.archType === 0) {
      if (isFront && stageGmLocation === EBiteJump.BEGINNING) {
        return <div style={{ width: 60 }} />
      } else {
        return <></>
      }
    } else {
      if (isFront && stageGmLocation === EBiteJump.BEGINNING) {
        return (
          <div style={{ marginTop: 9, height: 9 + 32 }}>
            <StageGmButton
              width={60}
              height={singleStageHeight}
              percent={props.gmPercent}
              onClick={props.gmFrontButtonClickHandle}
            ></StageGmButton>
          </div>
        )
      } else if (!isFront && stageGmLocation === EBiteJump.END) {
        return (
          <div style={{ marginTop: 9, height: 9 + 32 }}>
            <StageGmButton
              width={60}
              height={singleStageHeight}
              percent={props.gmPercent}
              onClick={props.gmBackButtonClickHandle}
            ></StageGmButton>
          </div>
        )
      }
    }
  }

  useEffect(() => {
    // calcStageWidth()
  }, [props.countOfFoldGroup])

  useEffect(() => {
    loadStageData()
  }, [])

  // useEffect(() => {
  //   if(stageCurrentStep === -1) {
  //     props.setDefaultStep(props.archType, stageList.length - 1)
  //   }
  //   console.info("arch type:", props.archType, " stageCurrentStep:", stageCurrentStep)
  //   // stepChangeHandler(archType, stageCurrentStep)
  // }, [stageCurrentStep]);

  useEffect(() => {
    loadStageData()
    setIsAddMore(false)
  }, [props.nodes])

  useEffect(() => {
    if (props.currentStep < props.nodes.length) {
      setIsAddMore(false)
    }
  }, [props.currentStep])

  useEffect(() => {
    if (isAddMore) {
      if (props.setMoreStep) {
        props.setMoreStep(props.nodes.length)
      }

      stageControl.SetAddMoreFoFinalStage(props.archType, true)
      // stagingManager.addNormalNode(
      //   props.archType === 0,
      //   props.nodes.length-1,
      //   true,
      // )
    } else {
      stageControl.SetAddMoreFoFinalStage(props.archType, false)
      // stagingManager.deleteKeyNode(props.archType === 0, props.nodes.length)
    }
  }, [isAddMore])

  useEffect(() => {
    //"": normal type
    if (props.uiShowType !== "") {
      setIsAddMore(false)
      if (props.setMoreStep) {
        if (props.currentStep > props.nodes.length - 1) {
          props.setMoreStep(props.nodes.length - 1)
        }
      }
    }
  }, [props.uiShowType])

  useEffect(() => {
    // 这里的代码会在每次渲染后执行
    // console.info("stage arch:" + props.archType + "render finished: " + stageList.length)
    props.loadFinished(props.archType)
  })

  const updataState = () => {
    if (!wasmModule.isFinishedOpencase) return
    const { attachment, toothlist, ipr } =
      caseManagement.getAttachmentIPRReport(true)
    const { lowlist, uplist } = toothlist
    const list = lowlist.concat(uplist)
    console.log("ipr================", ipr)
    dispatch(
      setReportData({
        attachment: attachment,
        toothlist: list,
        iprData: ipr,
      }),
    )
  }

  /**
   * Updata IPR Data
   */
  const upload = async () => {
    try {
      if (!wasmModule.isFinishedOpencase) return
      const res = await caseManagement.getCaseFiles(["bulk2"])
      const zips = []
      if (res) {
        for (const k in res) {
          zips.push({
            fileName: k,
            file: res[k],
          })
        }
        await dispatch<any>(
          uploadCaseZips({
            zips,
            patientId,
            caseId,
          }),
        )

        return Promise.resolve(true)
      }
    } catch (e) {
      Promise.reject(false)
      console.log("upload error", e)
    }
  }

  return (
    <Box>
      <Stack direction="row" spacing={0}>
        {/* {loadGmButton(true)} */}

        <Box
          sx={{
            width: 3 + (singleStageWidth - props.actualSingleStageWidth) / 2,
            height: 49,
          }}
        ></Box>
        {loadStageUi()}

        {/* more stage */}
        {isAddMore ? (
          <Stack
            ref={(e: HTMLElement) => {
              callBackStepRef(e, stageList.length)
            }}
            direction="row"
            spacing={0}
            key={stageList.length + ""}
          >
            {judgeWhichItem(moreStageItem, stageList.length, [])}
          </Stack>
        ) : (
          <></>
        )}

        {/*add more button */}
        {/* <Stack direction="column" spacing={0}>
          <Box sx={{width: 1, height: props.archType === 0 ? (12+3+(singleStageHeight-14)/2) : (3+3+(singleStageHeight-14)/2)}}></Box>
          <StageMoreIcon visibility={(props.currentStep === (props.nodes.length-1) && props.nodes.length > 0 && !isNodeContains(props.nodes[props.nodes.length-1].nodeType, 14)
            && props.viewEdit && props.uiShowType === "") ? "" : "hidden"} onClick={addMoreHandler}/>
        </Stack> */}

        <Box
          sx={{
            width: 3 + (singleStageWidth - props.actualSingleStageWidth) / 2,
            height: 49,
          }}
        ></Box>

        {/* {loadGmButton(false)} */}
      </Stack>
      <DialogBox
        open={showDeleteNodeWarning}
        title="Warning"
        content={<>{"Do you want to delete this IPR stage?"}</>}
        actions={
          <>
            <UButton
              onClickHandler={() => {
                setShowDeleteNodeWarning(false)

                stagingIPR.removeIPRNode(props.archType, props.currentStep)
              }}
              variant={"text"}
              btnText={"Yes"}
            />
            <UButton
              onClickHandler={() => {
                setShowDeleteNodeWarning(false)
              }}
              variant={"text"}
              btnText={"Cancel"}
            />
          </>
        }
      ></DialogBox>
      <DialogBox
        open={showDeletePassiveAlignerNodeWarning}
        title="Warning"
        content={<>{"Do you want to delete passive aligner frame?"}</>}
        actions={
          <>
            <UButton
              onClickHandler={() => {
                setShowDeletePassiveAlignerNodeWarning(false)
                console.info(
                  "=====delete passive aligner node: ",
                  props.archName,
                  props.currentStep,
                )
                stagingManager.deletePassiveNode(
                  props.archType === 0,
                  props.currentStep,
                )
              }}
              variant={"text"}
              btnText={"Yes"}
            />
            <UButton
              onClickHandler={() => {
                setShowDeletePassiveAlignerNodeWarning(false)
              }}
              variant={"text"}
              btnText={"Cancel"}
            />
          </>
        }
      ></DialogBox>
      <DialogBox
        open={showCannotAddIprNodeWarning}
        title="Warning"
        content={<>{"No need to do more IPR."}</>}
        actions={
          <>
            <UButton
              onClickHandler={() => {
                setShowCannotAddIprNodeWarning(false)
              }}
              variant={"text"}
              btnText={"Ok"}
            />
          </>
        }
      ></DialogBox>
    </Box>
  )
}

export default StageArchForIpr
